<template>
	<v-container fluid class="pa-0" v-if="permisoVista('mantenimientopreventivo-calendario','u')">
		<SignalR path="/hub/mantenimiento" @change="onChangeSocket" />
		
		<v-dialog v-model="dialogConfirmarAsignacion" persistent max-width="500px">
			<v-card>
				<v-card-title style="word-break: break-word;">¿Está seguro de asignar esta tarea al operador?</v-card-title>
				<v-card-text>
					<p class="mb-0 text-subtitle-1">La tarea que desea asignar pertenece a un subdepartamento distinto al que pertenece el operador. ¿Desea asignarla de todos modos?</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						text
						color="success"
						@click="cerrarDialogConfirmarAsignacion()"
						:disabled="saving"
						>Cancelar</v-btn
					>
					<v-btn
						text
						color="error"
						@click="asignarTarea(true)"
						:disabled="saving"
						:loading="saving"
						>Aceptar</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogDescarga" persistent max-width="500px">
			<v-card>
				<v-card-title style="word-break: break-word"
					>Descargar Reporte de Tareas de Mantenimiento</v-card-title
				>
				<v-card-text>
					<v-container fluid>
						<v-row>
							<v-col cols="12">
								<datePicker
									v-model="filtrosDescarga.fechaInicio"
									format="YYYY-MM-DD"
									label="[Obligatorio] Fecha de Inicio"
									clearable
									:disabled="downloading"
									@input="errorFechaInicio = ''"
								></datePicker>
								<p
									v-if="errorFechaInicio"
									class="mb-0 red--text"
								>
									{{ errorFechaInicio }}
								</p>
							</v-col>
							<v-col cols="12">
								<datePicker
									v-model="filtrosDescarga.fechaFin"
									format="YYYY-MM-DD"
									label="[Opcional] Fecha de Fin"
									clearable
									:disabled="downloading"
									@input="errorFechaFin = ''"
								></datePicker>
								<p v-if="errorFechaFin" class="mb-0 red--text">
									{{ errorFechaFin }}
								</p>
							</v-col>
							<v-col cols="12">
								<v-autocomplete
									v-model="filtrosDescarga.idsPersonas"
									:label="computedLabelIdsPersonas"
									:items="operadores"
									:item-text="nombrePersona"
									item-value="idPersona"
									multiple
									clearable
									:disabled="downloading"
									chips
									deletable-chips
								></v-autocomplete>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						text
						color="success"
						:disabled="downloading"
						@click="cerrarDialogDescarga"
						>Cerrar</v-btn
					>
					<v-btn
						text
						color="primary"
						:disabled="downloading"
						:loading="downloading"
						@click="descargarReporte"
						>Descargar</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogNotificaciones" persistent max-width="500px">
			<v-card>
				<v-card-title style="word-break: break-word"
					>Enviar correos de notificación</v-card-title
				>
				<v-card-text>
					<v-container fluid>
						<v-row>
							<v-col cols="12">
								<v-autocomplete
									v-model="filtrosNotificacion.idsPersonas"
									:label="filtrosNotificacion.idsPersonas.length > 0 ? 'Personas' : 'Personas: Todas'"
									:items="operadores"
									:item-text="nombrePersona"
									item-value="idPersona"
									hint="Dejar en blanco para enviar a todos o seleccione manualmente"
									persistent-hint
									multiple
									clearable
									:disabled="sending"
									chips
									deletable-chips
								></v-autocomplete>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						text
						color="success"
						:disabled="sending"
						@click="cerrarDialogNotificacion"
						>Cerrar</v-btn
					>
					<v-btn
						text
						color="primary"
						:disabled="sending"
						:loading="sending"
						@click="enviarNotificaciones"
						>Enviar</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-row>
			<v-col cols="4" style="padding-top: 22px">
				<MenuDatepicker
					v-model="filtros.fecha"
					label="[Obligatorio] Fecha"
					clearable
					hide-details
					@input="getData()"
					:disabled="loading"
				/>
			</v-col>
			<v-col cols="4" style="padding-top: 22px">
				<v-select
					v-model="filtros.tipoMantenimiento"
					label="[Opcional] Tipo de Mantenimiento"
					:items="tiposMantenimientos"
					hide-details
					clearable
					@change="getData"
					:disabled="loading"
				></v-select>
			</v-col>
			<v-col cols="4">
				<v-autocomplete
					v-model="filtros.idsSubdepartamentos"
					label="[Opcional] Subdepartamentos"
					:items="subdepartamentos"
					:item-text="nombreSubdepto"
					item-value="idSubdepartamento"
					hide-details
					clearable
					multiple
					chips
					deletable-chips
					:loading="loadingSubdeptos"
					:disabled="loading"
					@change="getData"
				></v-autocomplete>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="4" class="py-0 d-flex align-center">
				<v-btn
					color="blue darken-2"
					text
					@click="showDialogDescargar"
					:disabled="loading || filtros.fecha == null || !hayDatos"
				>
					Descargar Reporte de<br />Tareas de Mantenimiento
				</v-btn>
				<v-btn
					color="blue darken-2"
					text
					@click="showDialogNotificaciones"
					:disabled="loading || filtros.fecha == null || !hayDatos"
				>
					Enviar correos de<br>notificación
				</v-btn>
			</v-col>
		</v-row>
		<div
			v-if="!escenarioValido"
			class="mt-6 loading-container d-flex justify-center"
		>
			<div
				v-if="filtros.fecha == null"
				class="align-self-center text-center"
			>
				<v-icon size="140" color="grey">mdi-table-cog</v-icon>
				<p
					class="font-weight-bold"
					style="font-size: 2rem !important; color: #9e9e9e"
				>
					Seleccione una fecha
				</p>
			</div>
			<div v-else-if="loading" class="align-self-center text-center">
				<v-progress-circular
					indeterminate
					size="100"
					width="7"
					color="blue darken-2"
				></v-progress-circular>
				<p class="text-h4">Cargando</p>
			</div>
			<div v-else-if="!hayDatos" class="align-self-center text-center">
				<v-icon size="140" color="grey">mdi-table-cog</v-icon>
				<p
					class="font-weight-bold"
					style="font-size: 2rem !important; color: #9e9e9e"
				>
					{{
						operadores.length == 0
							? "No hay operadores disponibles"
							: "No hay datos disponibles"
					}}
				</p>
			</div>
		</div>
		<div v-else class="mt-6 d-flex justify-center flex-column">
			<div style="height: 0.75rem">
				<v-progress-linear
					v-if="saving"
					indeterminate
					color="blue darken-2"
				></v-progress-linear>
			</div>
			<div class="d-flex justify-center">
				<ColumnTablero
					v-for="(tarea, index) in tareas"
					:key="`column-${index}`"
					class="mr-3 operadores-container"
					:item="tarea"
					:saving="saving"
					:disabled="cardDisabled"
					@change="procesarAsignacionTarea"
				/>
				<div class="d-flex operadores-container">
					<ColumnTablero
						v-for="operador in operadores"
						:key="operador.idPersona"
						class="mr-3"
						:color="operador.color"
						:item="operador"
						:saving="saving"
						:disabled="cardDisabled"
						@change="procesarAsignacionTarea"
					/>
				</div>
			</div>
		</div>
	</v-container>
</template>

<script>
import { defineAsyncComponent } from "vue";
import axios from "axios";
import qs from "qs";
import moment from "moment";
import { mapState } from "vuex";
import MenuDatepicker from '../../MenuDatepicker.vue';
import SignalR from '../../SignalR.vue';

export default {
	components: {
		MenuDatepicker,
		SignalR,
		ColumnTablero: defineAsyncComponent(() =>
			import("./Tablero/ColumnTablero.vue")
		),
	},
	data() {
		return {
			tiposEstados: {
				iniciar: 1,
				unirse: 2,
				salirse: 3,
				finalizar: 4,
				asignar: 5
			},
			dialogNotificaciones: false,
			sending: false,
			dialogConfirmarAsignacion: false,
			lastAdded: null,
			lastRemoved: null,
			errorFechaInicio: "",
			errorFechaFin: "",
			errorPersonas: "",
			downloading: false,
			filtrosNotificacion: {
				fecha: null,
				idsPersonas: [],
			},
			defaultFiltrosNotificacion: {
				fecha: null,
				idsPersonas: [],
			},
			filtrosDescarga: {
				fechaInicio: undefined,
				fechaFin: undefined,
				idsPersonas: [],
			},
			defaultFiltrosDescarga: {
				fechaInicio: undefined,
				fechaFin: undefined,
				idsPersonas: [],
			},
			dialogDescarga: false,
			subdepartamentos: [],
			loadingSubdeptos: false,
			tareas: [],
			operadores: [],
			filtros: {
				fecha: undefined,
				tipoMantenimiento: undefined,
				idsSubdepartamentos: [],
			},
			tiposMantenimientos: [
				{
					text: "Preventivo",
					value: 1,
				},
				{
					text: "Correctivo",
					value: 2,
				},
				{
					text: "Inspección",
					value: 3,
				},
				{
					text: "Servicio",
					value: 4,
				},
			],
			loading: false,
			saving: false,
			cardDisabled: false
		};
	},
	computed: {
		...mapState(["token"]),
		escenarioValido() {
			return !(
				this.loading ||
				this.filtros.fecha == null ||
				!this.hayDatos
			);
		},
		computedLabelIdsPersonas() {
			return this.filtrosDescarga.idsPersonas.length > 0
				? "[Opcional] Personas"
				: "[Opcional] Personas: Todas";
		},
		hayDatos() {
			//Caso 1: Si hay tareas debe haber operadores
			const caso1 =
				this.tareas[0].tareasAsignadas.length > 0 &&
				this.operadores.length > 0;
			//Caso 2: Si hay operadores debe haber tareas dentro de los mismos operadores o en tareas sin asignar
			const caso2 =
				(this.operadores.length > 0 &&
					this.tareas[0].tareasAsignadas.length > 0) ||
				(this.operadores.length > 0 &&
					this.operadores.reduce(
						(acumulador, objeto) =>
							acumulador + objeto.tareasAsignadas.length,
						0
					) > 0);

			return caso1 || caso2;
		},
	},
	mounted() {
		this.initialize();
	},
	methods: {
		onChangeSocket(event) {
			const parsedParams = this.getParsedParams(event);

			if (parsedParams.estado == this.tiposEstados["finalizar"]) {
				this.getData();
			}
		},
		getParsedParams(params){
			const parsedParams = qs.parse(params);
			const jsonParsedParams = Object.keys(parsedParams).reduce((acc, key) => {
				const normalizedKey = key[0].toLowerCase() + key.slice(1);
				acc[normalizedKey] = Number(parsedParams[key]);
				return acc;
			}, {});
			return jsonParsedParams;
		},
		showDialogNotificaciones(){
			this.filtrosNotificacion.fecha = this.filtros.fecha;

			this.dialogNotificaciones = true;
		},
		enviarNotificaciones(){
			this.sending = true;

			axios
				.get('/Mantenimientos/EnviarNotificaciones',{
					params: this.filtrosNotificacion,
					paramsSerializer: (params) =>
						qs.stringify(params, { indices: false, skipNulls: true }),
				})
				.then( () => {
					this.sending = false;
					this.cerrarDialogNotificacion();
				})
				.catch( (error) => {
					this.sending = false;
					console.log(error);
				});
		},
		cerrarDialogNotificacion(){
			this.dialogNotificaciones = false;
			this.$nextTick( () => {
				this.filtrosNotificacion = JSON.parse(JSON.stringify(this.defaultFiltrosNotificacion));
			});
		},
		cerrarDialogConfirmarAsignacion(){
			this.dialogConfirmarAsignacion = false;

			this.$nextTick( () => {
				this.revertirUltimoMovimiento();
			});
		},
		cerrarDialogDescarga() {
			this.dialogDescarga = false;
			this.$nextTick().then(() => {
				this.filtrosDescarga = JSON.parse(
					JSON.stringify(this.defaultFiltrosDescarga)
				);
				this.errorFechaInicio = "";
				this.errorFechaFin = "";
				this.errorPersonas = "";
			});
		},
		nombrePersona: ({ nombre, paterno, materno }) =>
			`${nombre ? `${nombre} ` : ""}${paterno ? `${paterno} ` : ""}${
				materno ? `${materno} ` : ""
			}`.trim(),
		showDialogDescargar() {
			this.filtrosDescarga = JSON.parse(
				JSON.stringify(this.defaultFiltrosDescarga)
			);
			this.filtrosDescarga.fechaInicio = this.filtros.fecha;
			this.dialogDescarga = true;
		},
		validateDescarga() {
			this.errorFechaInicio = "";
			this.errorFechaFin = "";
			this.errorPersonas = "";

			if (this.filtrosDescarga.fechaInicio == null) {
				this.errorFechaInicio = "Requerido";
			}

			// if(this.filtrosDescarga.fechaFin == null){
			// 	this.errorFechaFin = 'Requerido';
			// }

			return this.errorFechaInicio == "";
		},
		descargarReporte() {
			if (!this.validateDescarga()) return;

			this.downloading = true;

			const datetime = moment().format("YYYYMMDDHHmmss");
			axios({
				url: "/Mantenimientos/ImprimirAsignaciones",
				params: {
					...this.filtrosDescarga,
					token: this.token,
				},
				paramsSerializer: (params) =>
					qs.stringify(params, { indices: false }),
				method: "GET",
				responseType: "blob",
			})
				.then((response) => {
					let blob = new Blob([response.data], {
						type: "application/zip",
					});
					let a = document.createElement("a");
					let blobURL = URL.createObjectURL(blob);
					a.download = `reporte-tareas-mantenimiento-${datetime}.zip`;
					a.href = blobURL;
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					this.downloading = false;
					this.cerrarDialogDescarga();
				})
				.catch((error) => {
					this.downloading = false;
					console.log(error);
				});
		},
		nombreSubdepto: ({ codigo, nombre }) =>
			codigo ? `[${codigo}] - ${nombre}`.trim() : `${nombre}`.trim(),
		initialize() {
			this.getData();
			this.getSubdepartamentos();
		},
		getSubdepartamentos() {
			this.loadingSubdeptos = true;
			axios
				.get("/Subdepartamento")
				.then((response) => {
					this.subdepartamentos = response.data;
				})
				.catch(console.log)
				.finally(() => {
					this.loadingSubdeptos = false;
				});
		},
		esAsignacionValida() {
			if (!this.lastAdded.item.hasOwnProperty("idPersona")) return true;

			//En caso contrario la tarea se puede asignar a cualquier operador si es un colaborador
			if(this.lastAdded.item.colaborador) return true;

			//Si la tarea es de un subdepartamento solo se puede asignar a operadores con subdepartamentos validos
			if (this.lastAdded.element.idSubdepartamento == null) return true;
			
			//La tarea solo se puede asignar a operadores con subdepartamentos validos
			const subdeptoValido = this.lastAdded.item.idsSubdepartamentos.includes(
				this.lastAdded.element.idSubdepartamento
			);

			if(!subdeptoValido) this.dialogConfirmarAsignacion = true;
			
			return subdeptoValido;
		},
		revertirUltimoMovimiento() {
			const indexLastAdded =
				this.lastAdded.item.tareasAsignadas.findIndex(
					(tarea) =>
						tarea.idMantenimientoCalendarioInspeccion ==
							this.lastAdded.element
								.idMantenimientoCalendarioInspeccion &&
						tarea.idMantenimientoTarea ==
							this.lastAdded.element.idMantenimientoTarea
				);

			this.lastAdded.item.tareasAsignadas.splice(indexLastAdded, 1);

			this.lastRemoved.item.tareasAsignadas.splice(
				this.lastRemoved.oldIndex,
				0,
				{
					...this.lastRemoved.element,
				}
			);
		},
		procesarAsignacionTarea(event, item) {
			const eventKey = Object.keys(event)[0];
			if (eventKey == "added") {
				this.lastAdded = {
					element: event.added.element,
					item,
				};
			} else if (eventKey == "removed") {
				this.lastRemoved = {
					element: event.removed.element,
					oldIndex: event.removed.oldIndex,
					item,
				};
			}

			if (eventKey != "removed") return;

			//Validar asignacion de tarea con el subdepartamento destino
			if (!this.esAsignacionValida()) {
				// this.revertirUltimoMovimiento();
				return;
			}

			this.asignarTarea();
		},
		asignarTarea(autorizar = false) {
			this.saving = true;
			axios
				.put("/Mantenimientos/AsignarTareaOInspeccion", {
					idMantenimientoTarea:
						this.lastAdded.element.idMantenimientoTarea,
					idMantenimientoCalendarioInspeccion:
						this.lastAdded.element
							.idMantenimientoCalendarioInspeccion,
					idPersona: this.lastAdded.item?.idPersona,
					idPersonaAnterior: this.lastRemoved.item?.idPersona,
					autorizar
				})
				.catch((error) => {
					console.log(error);
					this.revertirUltimoMovimiento();
					this.animacionError();
				})
				.finally(() => {
					this.saving = false;
					if(autorizar) this.dialogConfirmarAsignacion = false;
				});
		},
		getData(enableLoading = true) {
			if (this.filtros.fecha == null) return;

			if (enableLoading) this.loading = true;

			axios
				.get("/Mantenimientos/ListarTareasMantenimiento", {
					params: this.filtros,
					paramsSerializer: (params) =>
						qs.stringify(params, { indices: false }),
				})
				.then((response) => {
					this.tareas = [
						{
							tareasAsignadas: response.data.tareasSinAsignar,
						},
					];
					this.operadores = response.data.operadores;
				})
				.catch(console.log)
				.finally(() => {
					if (enableLoading) this.loading = false;
				});
		},
		animacionError(){
			this.cardDisabled = true;
			this.$set(this.lastRemoved.item.tareasAsignadas[this.lastRemoved.oldIndex],'animar',true);
			this.$set(this.lastRemoved.item.tareasAsignadas[this.lastRemoved.oldIndex],'animarTexto',true);
			setTimeout(() => {
				this.$set(this.lastRemoved.item.tareasAsignadas[this.lastRemoved.oldIndex],'animar',false);
				this.$set(this.lastRemoved.item.tareasAsignadas[this.lastRemoved.oldIndex],'animarTexto',false);
				this.cardDisabled = false;
			}, 1500);
		}
	},
};
</script>

<style scoped>
.operadores-container {
	overflow-x: auto;
}

.loading-container {
	height: calc(100vh - 21.875rem);
}
</style>